<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="featuresPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
          <h3>Clearance Information</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="6">
              <h3 class="withBackground px-2">Minimum Vertical Clearance</h3>

              <LabelText
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                id="txt_Over_Structure"
                label="SC.01 Over Structure"
                v-model="structure.structureBridge.vclrOver"
                maxlength="5"
                appendWith=" ft"
                :decimalPlaces="2"
                type="number"
              >
              </LabelText>

              <LabelSelect
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                selectXl="6"
                selectLg="6"
                selectMd="6"
                selectSm="6"
                id="label_Under_Reference"
                label="SC.02 Under (Reference)"
                :refTable="REFERENCE_TABLE.MINIMUM_UNDERCLEARANCE"
                v-model="structure.structureBridge.refVuc"
              >
              </LabelSelect>

              <LabelText
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                id="txt_Under_Clearance"
                label="SC.03 Under Clearance"
                v-model="structure.structureBridge.vclrUnder"
                maxlength="5"
                appendWith=" ft"
                :decimalPlaces="2"
                type="number"
              >
              </LabelText>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="6">
              <h3 class="withBackground px-2">Minimum Lateral Clearance</h3>

              <LabelSelect
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                selectXl="6"
                selectLg="6"
                selectMd="6"
                selectSm="6"
                id="label_Reference_Feature"
                label="SC.04 Reference Feature"
                :refTable="REFERENCE_TABLE.MINIMUM_UNDERCLEARANCE"
                v-model="structure.structureBridge.refHuc"
              >
              </LabelSelect>

              <LabelText
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                id="txt_Under_Right"
                label="SC.05 Under Right"
                v-model="structure.structureBridge.hclrUrt"
                maxlength="4"
                appendWith="ft"
                :decimalPlaces="1"
                type="number"
              >
              </LabelText>

              <LabelText
                labelXl="5"
                labelLg="5"
                labelMd="5"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                id="txt_Under_Left"
                label="SC.06 Under Left"
                v-model="structure.structureBridge.hclrUlt"
                maxlength="5"
                appendWith="ft"
                :decimalPlaces="1"
                type="number"
              >
              </LabelText>
            </v-col>
          </v-row>

          <v-col class="px-0" xs="12" sm="12" md="12" lg="12">
            <h3 class="withBackground px-2">Navigation Control</h3>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="5"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="label_Nav_Control_Exists"
                  label="B.N.01 Navigable Waterway?"
                  :refTable="REFERENCE_TABLE.NAVIGATION_CONTROL"
                  v-model="structure.structureBridge.navCntrol"
                >
                </LabelSelect>

                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="5"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="txt_Nav_Horizontal_Clearance"
                  label="B.N.05 Nav Horizontal Clearance"
                  v-model="structure.structureBridge.navHc"
                  maxlength="22"
                  appendWith=" ft"
                  :decimalPlaces="2"
                  type="number"
                >
                </LabelText>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="6">
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="5"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="txt_Min_Vertical_Lift_Clearance"
                  label="B.N.02 Min. Vert. Clr"
                  v-model="structure.structureBridge.lftbrnavcl"
                  maxlength="22"
                  appendWith=" ft"
                  :decimalPlaces="2"
                  type="number"
                >
                </LabelText>
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="5"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="txt_Nav_Vertical_Clearance"
                  label="B.N.03 Nav Vertical Clearance"
                  v-model="structure.structureBridge.navVc"
                  maxlength="22"
                  appendWith=" ft"
                  :decimalPlaces="2"
                  type="number"
                >
                </LabelText>
              </v-col>
            </v-row>
          </v-col>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />

          <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />

          <h3>Feature Intersection Details</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row class="mb-8">
            <v-col sm="12">
              <v-data-table
                class="noScrollTable compactTable"
                :items="mergedTableData"
                :headers="inspectionDetailsHeaders"
                v-model:expanded="expandedRows"
                hide-default-footer
                :items-per-page="-1"
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.onUnder`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.featureName`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.featureType`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.action`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:item="{ item }">
                  <tr :class="rowClass(item)">
                    <td class="text-center">
                      <template v-if="!anyDetailEditable">
                        <button v-if="!isExpanded(item)" @click="toggleRow(item)">
                          <v-icon
                            :id="`icon_Chevron_Right_${item.brkey}_${item.onUnder}`"
                            icon="fa-solid fa-chevron-right"
                          ></v-icon>
                        </button>

                        <button v-if="isExpanded(item)" @click="toggleRow(item)">
                          <v-icon
                            :id="`icon_Chevron_Down_${item.brkey}_${item.onUnder}`"
                            icon="fa-solid fa-chevron-down"
                          ></v-icon>
                        </button>
                      </template>
                    </td>
                    <td class="alignCenter">
                      {{ item?.onUnder ? configStore.getReferenceValue(REFERENCE_TABLE.ON_UNDER, item?.onUnder) : "" }}
                    </td>
                    <td class="alignCenter ellipsisText">
                      <span>{{ getRoadName(item) }}</span>
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.featureType
                          ? configStore.getReferenceValue(REFERENCE_TABLE.FEATURE_TYPE, item?.featureType)
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      <div v-if="item?.featureType === '1' || item?.featureType === '4'">
                        <div style="white-space: nowrap" v-if="isExpanded(item) && anyDetailEditable && isEditable">
                          <IconTooltip
                            id="icon_add"
                            icon="fa-solid fa-check"
                            :tooltip="item?.isAdd ? 'Add' : 'Update'"
                            @click="saveDetail(item)"
                          />
                          <IconTooltip id="icon_close" icon="fa-solid fa-xmark" tooltip="Close" @click="closeDetail" />
                        </div>
                        <div
                          style="white-space: nowrap"
                          v-else-if="isEditable && (expandedRows?.length == 0 || !anyDetailEditable)"
                        >
                          <IconTooltip
                            id="icon_edit"
                            icon="fa-solid fa-pencil"
                            tooltip="Edit"
                            @click="editDetail(item)"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="inspectionDetailsHeaders.length">
                    <InspectionFeaturesHighway
                      ref="highwayRef"
                      :rowId="item.rowId + ''"
                      :readOnly="!anyDetailEditable"
                      @changes-detected-highway="changesDetected = true"
                      v-if="item.featureType === '1' || item.featureType === '4'"
                      @updated-new-wear-surface="updatedNewWearSurface"
                    />

                    <InspectionFeaturesWaterway :rowId="item.rowId + ''" v-if="item.featureType === '3'" />

                    <InspectionFeaturesRailroad :rowId="item.rowId + ''" v-if="item.featureType === '2'" />
                  </td>
                </template>
                <template v-slot:bottom> </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
  </v-row>
</template>

<script>
import { ref, computed, watch } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import { useConfigStore } from "@/stores/config";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import LabelText from "@/components/common/LabelText.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import { BUTTONS } from "@/constants/CommonWebConstants";
import InspectionFeaturesHighway from "@/components/inspection/featureComponents/InspectionFeaturesHighway.vue";
import InspectionFeaturesRailroad from "@/components/inspection/featureComponents/InspectionFeaturesRailroad.vue";
import InspectionFeaturesWaterway from "@/components/inspection/featureComponents/InspectionFeaturesWaterway.vue";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useSnackbarStore } from "@/stores/snackbar";

export default {
  name: "InspectionFeatures",
  data() {
    return {
      inspectionDetailsHeaders: [
        { key: "data-table-expand" },
        {
          line1: "F.02",
          line2: "On/Under",
          line3: null,
          sortable: false,
          key: "onUnder",
        },
        {
          line1: "B.F.03",
          line2: "Feature Name",
          line3: null,
          sortable: false,
          key: "featureName",
        },
        {
          line1: "F.03",
          line2: "Feature Type",
          line3: null,
          sortable: false,
          key: "featureType",
        },
        {
          line1: null,
          line2: "Action",
          line3: null,
          sortable: false,
          key: "action",
        },
      ],
    };
  },
  setup() {
    const allPanels = [0, 1];
    const panel = ref([0, 1]);
    const inspectionStore = useInspectionStore();
    const snackbarStore = useSnackbarStore();
    const configStore = useConfigStore();
    const closeConfirm = ref(null);
    let snackBarId = ref("");
    const isEditable = computed(() => {
      return inspectionStore.isEditable;
    });
    if (!isEditable.value) {
      panel.value = allPanels;
    }

    let highwayRef = ref(null);

    let featureIntersectionDetailsForm = ref(null);
    let validDetails = ref(false);
    let changesDetected = ref(false);
    let structure = computed(() => inspectionStore.selectedInspection);
    let mergedTableData = computed(() => inspectionStore.getFeatureIntersectionTableData());
    let expandedRows = ref([]);
    let changesNewWearSurfaceDetected = ref(false);
    let localNewWearSurface = ref(structure.value.userInspection.newWs);

    const rowClass = (data) => {
      return expandedRows.value?.find((a) => a.featureKey === data.featureKey) ? "rowSelect" : "rowUnselect";
    };

    const anyDetailEditable = computed(() => {
      return inspectionStore.getAddingOrEditing;
    });

    const isExpanded = (details) => {
      return (
        expandedRows.value?.findIndex((a) => a?.brkey === details.brkey && a?.featureKey === details.featureKey) >= 0
      );
    };

    function editDetail(detail) {
      inspectionStore.setAddingOrEditing(true);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.FEATURE_INTERSECTION_DETAILS_DATATABLE,
      });
      expandedRows.value = [detail];
      changesDetected.value = false;
    }

    const toggleRow = (detail) => {
      if (expandedRows.value?.includes(detail)) {
        const index = expandedRows.value.findIndex(
          (a) => a?.brkey === detail.brkey && a?.featureKey === detail.featureKey,
        );
        expandedRows.value.splice(index, 1);
      } else {
        expandedRows.value.push(detail);
      }
    };

    const updatedNewWearSurface = (updatedValue) => {
      changesDetected.value = true;
      localNewWearSurface.value = updatedValue;
    };

    async function saveDetail(detail) {
      let isValid = await highwayRef.value.validate();
      if (isValid) {
        inspectionStore.setShowValidationSnackbar(false);
        inspectionStore.saveFeatureInspectionDetails(detail);
        if (changesDetected.value) {
          inspectionStore.setDirtyFlag(true);
          structure.value.userInspection.newWs = localNewWearSurface.value;
        }

        expandedRows.value = [];
        inspectionStore.setAddingOrEditing(false);
        snackbarStore.removeMessage(snackBarId.value);
      } else {
        inspectionStore.setShowValidationSnackbar(true);
      }
    }

    const closeDetail = () => {
      if (isEditable.value && changesDetected.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              expandedRows.value = [];
              inspectionStore.setAddingOrEditing(false);
              snackbarStore.removeMessage(snackBarId.value);
              changesDetected.value = false;
            }
          });
      } else {
        expandedRows.value = [];
        inspectionStore.setAddingOrEditing(false);
        snackbarStore.removeMessage(snackBarId.value);
      }
    };

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const getRoadName = (detail) => {
      if (detail?.featureType == "2") {
        return detail.rrName ? configStore.getReferenceValue(REFERENCE_TABLE.RAILROAD_NAME, detail?.rrName) : "";
      } else {
        return detail.roadwayName;
      }
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      () => [structure.value.userRWays, structure.value.Roadway, structure.value.userInspection],
      () => {
        inspectionStore.setDirtyFlag(true);
      },
      { deep: true },
    );

    return {
      highwayRef,
      toggleRow,
      panel,
      REFERENCE_TABLE,
      isEditable,
      structure,
      configStore,
      featureIntersectionDetailsForm,
      saveDetail,
      validDetails,
      changesDetected,
      mergedTableData,
      isExpanded,
      anyDetailEditable,
      editDetail,
      rowClass,
      expandedRows,
      closeDetail,
      closeConfirm,
      BUTTONS,
      inspectionStore,
      INSPECTION_MESSAGES,
      changesNewWearSurfaceDetected,
      updatedNewWearSurface,
      toggleAllPanels,
      getRoadName,
      MODULE_TYPES,
    };
  },
  components: {
    DataTableHeader,
    LabelSelect,
    LabelText,
    IconTooltip,
    ConfirmDialog,
    InspectionFeaturesHighway,
    InspectionFeaturesRailroad,
    InspectionFeaturesWaterway,
    ExpandCollapseToggle,
  },
};
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;
th {
  text-align: center;
}
.alignCenter {
  text-align: center;
}
.alignEnd {
  text-align: end;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}
</style>
